export const CARA_HAPPY_EYES_CLOSE_MOUTH_OPEN = require('../general/cara_happy_eyes_close_mouth_open.png');
export const CARA_WOW = require('../general/cara_wow.png');
export const CARA_HAPPY_EYES_OPEN_MOUTH_CLOSE = require('../general/cara_happy_eyes_open_mouth_close.png');
export const CARA_HAPPY_EYES_OPEN_MOUTH_OPEN = require('../general/cara_happy_eyes_open_mouth_open.png');
export const CARA_HAPPY_EYES_CLOSE_MOUTH_CLOSE = require('../general/cara_happy_eyes_close_mouth_close.png');
export const CARA_SAD_EYES_OPEN_MOUTH_CLOSE = require('../general/cara_sad_eyes_open_mouth_close.png');
export const CARA_SAD_EYES_CLOSE_MOUTH_CLOSE = require('../general/cara_sad_eyes_close_mouth_close.png');
export const CARA_SAD_EYES_OPEN_MOUTH_OPEN = require('../general/cara_sad_eyes_open_mouth_open.png');
export const CARA_CALM = require('../general/cara_calm.png');
